import SplitSection from 'components/home-page-components/SplitSection'
import SectionColumn from 'components/home-page-components/SectionColumn'
import ColumnComponent from 'components/home-page-components/ColumnComponent'
import Collection from 'components/home-page-components/Collection'
import CollectionPreview from 'components/home-page-components/CollectionPreview'
import ImageSlider from 'components/home-page-components/ImageSlider'
import SingleImage from 'components/home-page-components/SingleImage'
import AgeRestrictedBlur from 'components/home-page-components/AgeRestrictedBlur'
import TextComponent from 'components/home-page-components/TextComponent'

export default async ({ app }) => {
  app.component('SplitSection', SplitSection)
  app.component('SectionColumn', SectionColumn)
  app.component('ColumnComponent', ColumnComponent)
  app.component('Collection', Collection)
  app.component('CollectionPreview', CollectionPreview)
  app.component('ImageSlider', ImageSlider)
  app.component('SingleImage', SingleImage)
  app.component('AgeRestrictedBlur', AgeRestrictedBlur)
  app.component('TextComponent', TextComponent)
}
